<template>
  <el-dialog
  :visible.sync="visible"
  title="精准餐单"
  fullscreen
  :before-close="handleClose"
  >
   <recipe :doctorId="doctorId" :hideTitle="true" :readOnly="true"/>
  </el-dialog>
</template>
<script>
import recipe from "../recipe/index.vue";
export default {
  props: ["visible","doctorId"],
  components: {
    recipe
  },
  data() {
    return {


    };
  },
  mounted(){


  },
  created() {

  },
  methods: {
    handleClose: function () {
      this.$emit('close');
    }
  },
};
</script>
<style lang="less" scoped="scoped">

</style>
